import React from 'react'


import {
  Icon,
  classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  string, func,
} from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

function ReviewsAreaButton({
  icon = NOOP,
  iconColor = '',
  backgroundColor = '',
  onClick: handleClick,
  text,
  className = '',
  onMouseEnter: handleMouseEnter,
  onTouchStart: handleTouchStart,
}) {
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      handleClick(event)
    }
  }

  const hasIcon = iconColor && typeof icon === 'function'

  const wrapperClasses = classnames(
    'area-action-button',
    className,
  )

  return (
    <div
      className={wrapperClasses}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onTouchStart={handleTouchStart}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label={text}
    >
      {backgroundColor && (
        <div className={`area-action-button__button area-action-button__button--${backgroundColor}`}>
          {hasIcon && <Icon svgComponent={icon} color={iconColor} size="small" notSpaced />}
        </div>
      )}
      <span className={classnames(
        'area-action-button__text',
        hasIcon ? 'with-icon' : ''
      )}>{text}</span>
    </div>
  )
}

ReviewsAreaButton.propTypes = {
  icon: func,
  iconColor: string,
  backgroundColor: string,
  onClick: func.isRequired,
  text: string.isRequired,
  className: string,
  onMouseEnter: func,
  onTouchStart: func,
}

export default ReviewsAreaButton
